module.exports = __webpack_public_path__ + "9c90ad8fcea38eaf49ee717fe15764cd.svg";